module.exports = __webpack_public_path__ + "img/wow.2a573ef3.webp";